import "./button.css";

export const Button = ({ type, href, children, onClick = () => {} }) => {
  const onButtonClick = (e) => {
    !type?.includes("submit") && e.preventDefault();
    onClick();
  };

  return type?.includes("submit") ? (
    <button type="submit" className={`button ${type}`} onClick={onButtonClick}>
      {children}
    </button>
  ) : (
    <a href={href || "#"} className={`button ${type}`} onClick={onButtonClick}>
      <>
        <div></div>
        <span>{children}</span>
      </>
    </a>
  );
};
